const teams =
{
    helmet :
    {
        title : 'Équipes' ,
        metas : []
    }
};

export default teams ;